<template>
  <div class="pa-4">
    <v-app-bar flat color="transparent" class="mb-2">
      <!-- MELHORIA: renomeado para "Sem JOB" (nomenclatura pedida pelo usuário) - o fluxo de
      criação passou a ser acessível também pelo botão "+" de Emissão de Nota
      (IssuanceInvoiceView.vue); esta tela/rota continuam existindo sem alteração funcional. -->
      <v-toolbar-title class="title">Notas Sem JOB</v-toolbar-title>
      <v-spacer />
      <v-btn color="primary" class="mr-2" @click="$router.push('/notaAvulsa/criar/venda')">
        <v-icon left small>mdi-plus</v-icon> Nota de Venda Sem JOB
      </v-btn>
      <v-btn color="primary" outlined @click="$router.push('/notaAvulsa/criar/remessa')">
        <v-icon left small>mdi-plus</v-icon> Nota de Remessa Sem JOB
      </v-btn>
    </v-app-bar>

    <v-alert type="info" outlined dense class="mb-4">
      Notas de Venda e Remessa emitidas <b>sem vínculo a Job/Ordem de Serviço</b>. Consulte a PlugNotas
      diretamente para status detalhado de uma nota específica.
    </v-alert>

    <v-card outlined>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="notas"
          :loading="carregando"
          no-data-text="Nenhuma nota avulsa criada ainda."
        >
          <template v-slot:item.tipoNotaFiscal="{ item }">
            {{ item.tipoNotaFiscal === 'Nota Fiscal de Remessa' ? 'Remessa' : 'Venda' }}
          </template>
          <template v-slot:item.destino="{ item }">
            {{ item.destinatarioNome || item.destinatarioFornecedorNome || '-' }}
          </template>
          <template v-slot:item.createAt="{ item }">
            {{ item.createAt ? new Date(item.createAt).toLocaleString('pt-BR') : '-' }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn small text color="primary" @click="$router.push(`/notaAvulsa/criar/${item.tipoNotaFiscal === 'Nota Fiscal de Remessa' ? 'remessa' : 'venda'}?id=${item.id}`)">
              Abrir
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'NotaAvulsaListView',
  data() {
    return {
      carregando: false,
      notas: [],
      headers: [
        { text: 'Tipo', value: 'tipoNotaFiscal' },
        { text: 'Destinatário', value: 'destino' },
        { text: 'Status', value: 'statusNf' },
        { text: 'Criada em', value: 'createAt' },
        { text: '', value: 'actions', sortable: false }
      ]
    };
  },
  methods: {
    async carregarNotas() {
      this.carregando = true;
      try {
        // Filtra client-side pelas notas cujo FisPreDocEmi não tem "job" preenchido — é essa a
        // marca de uma nota avulsa (não inventamos nenhum campo novo no schema; ver comentário em
        // CriarNotaAvulsaView.vue::salvarNota). Busca as notas mais recentes e resolve o vínculo
        // com FisPreDocEmi para aplicar o filtro.
        // BUGFIX: o enum real do schema EmissaoNotasFiscais.tipoNotaFiscal usa espaço ("Nota
        // Fiscal" / "Nota Fiscal de Remessa" — confirmado via GET /schema/EmissaoNotasFiscais e
        // nos registros reais gravados), não underscore. Era por isso que a nota de teste (e
        // qualquer nota nova) não aparecia aqui: o valor salvo (após corrigir o outro bug em
        // salvarNota()) nunca batia com o filtro underscore usado nesta busca.
        const response = await Vue.prototype.$http.get('/Entity/EmissaoNotasFiscais/search-fields', {
          params: {
            searchFields: 'tipoNotaFiscal',
            value: '[Nota Fiscal,Nota Fiscal de Remessa]',
            mode: 'Equals',
            page: 1,
            limit: 200,
            sortField: 'createAt',
            sortOrder: 'desc'
          }
        });

        const candidatas = response.data.data.data || [];
        const comNotaFiscalId = candidatas.filter((n) => n.notaFiscal);

        if (comNotaFiscalId.length === 0) {
          this.notas = [];
          return;
        }

        const idsNotaFiscal = [...new Set(comNotaFiscalId.map((n) => n.notaFiscal))];

        // BUGFIX (achado ao investigar a listagem vazia): buscar todos os ids de uma vez numa
        // única query string quebra assim que o total de EmissaoNotasFiscais no ambiente passa de
        // ~140 — a URL do GET fica grande demais, a requisição falha sem response HTTP algum, e
        // como o apiClient (ver CLAUDE.md) faz "return error.response.data" incondicionalmente no
        // interceptor de erro, isso lança um TypeError ("Cannot read properties of undefined
        // (reading 'data')") que não é pego aqui (o try/finally original não tinha catch) e aborta
        // a função inteira antes de preencher "this.notas" — por isso a nota de teste continuava
        // não aparecendo mesmo já com o registro salvo corretamente. Mesmo bug e mesma causa raiz
        // já resolvidos antes em IssuanceInvoiceView.vue::enrichInvoiceDisplayValues (ver
        // comentário lá) — aplicando aqui a mesma solução: buscar em lotes (chunks).
        const CHUNK_SIZE = 40;
        const idChunks = [];
        for (let i = 0; i < idsNotaFiscal.length; i += CHUNK_SIZE) {
          idChunks.push(idsNotaFiscal.slice(i, i + CHUNK_SIZE));
        }

        // BUGFIX (achado ao investigar "mensagem de erro no grid"): o ambiente tem alguns
        // registros antigos de FisPreDocEmi que o backend não consegue nem ler (GET direto por id
        // já retorna 400 "Server Error: Exception has been thrown by the target of an invocation." —
        // problema de dado/registro no backend, não relacionado a este código). Como o
        // apiClient.js dispara automaticamente um toast global (Vue.prototype.$notfy.error) para
        // QUALQUER resposta HTTP de erro (ver interceptor de resposta em apiClient.js), sempre que
        // um desses registros corrompidos caía dentro de um lote (chunk) de ids, o usuário via um
        // toast de erro aparecer na tela mesmo a lista final carregando corretamente (os ids
        // problemáticos simplesmente não entram no Map e a nota correspondente fica de fora do
        // filtro). Para não expor esse ruído (sobre um problema que não impede a tela de funcionar),
        // sobrescrevemos o validateStatus só nestas chamadas para aceitar qualquer status HTTP —
        // assim a resposta de erro é tratada aqui mesmo (success:false, sem entradas no Map) em vez
        // de passar pelo interceptor de erro global que dispara o toast.
        const fisPreDocEmiResponses = await Promise.all(
          idChunks.map((chunk) => Vue.prototype.$http.get('/Entity/FisPreDocEmi/search-fields', {
            params: { ids: chunk.join(','), limit: chunk.length },
            validateStatus: () => true
          }))
        );
        const fisPreDocEmiMap = new Map(
          fisPreDocEmiResponses.flatMap((r) => r.data?.data?.data || []).map((f) => [f.id, f])
        );

        this.notas = comNotaFiscalId
          .filter((n) => {
            const fis = fisPreDocEmiMap.get(n.notaFiscal);
            return fis && !fis.job;
          })
          .sort((a, b) => new Date(b.createAt) - new Date(a.createAt));
      } catch (err) {
        // BUGFIX: não existia catch aqui — qualquer falha (ex.: a de URL longa acima, antes da
        // correção) deixava a lista silenciosamente vazia, sem nenhum aviso. Agora ao menos avisa
        // o usuário em vez de simplesmente não mostrar nada.
        console.error('Erro ao carregar notas avulsas:', err);
        this.$notfy?.error?.('Erro ao carregar a lista de notas avulsas. Tente recarregar a página.');
        this.notas = [];
      } finally {
        this.carregando = false;
      }
    }
  },
  async created() {
    await this.carregarNotas();
  }
};
</script>
